import { render } from "./build-a-website.vue?vue&type=template&id=8639e8b4&ts=true"
import script from "./build-a-website.vue?vue&type=script&lang=ts"
export * from "./build-a-website.vue?vue&type=script&lang=ts"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__